module.exports = __webpack_public_path__ + "img/activity_fun2.2bbcfb63.jpg";